// Curated word list for Hangman game
// Extracted from portfolio copy files with balanced categories

const TECH_TERMS = 'Tech Terms';
const JOB_ROLES_AND_SKILLS = 'Job Roles & Skills';
const PERSONAL_DETAILS = 'Personal Details';
const SOFT_SKILLS_AND_VALUES = 'Soft Skills & Values';

export const sections = [
  TECH_TERMS,
  JOB_ROLES_AND_SKILLS,
  PERSONAL_DETAILS,
  SOFT_SKILLS_AND_VALUES,
];

export const words = [
  // Tech Terms (technologies, frameworks, tools)
  { word: 'aws', category: TECH_TERMS },
  { word: 'docker', category: TECH_TERMS },
  { word: 'git', category: TECH_TERMS },
  { word: 'graphql', category: TECH_TERMS },
  { word: 'hubspot', category: TECH_TERMS },
  { word: 'jest', category: TECH_TERMS },
  { word: 'jira', category: TECH_TERMS },
  { word: 'mysql', category: TECH_TERMS },
  { word: 'node', category: TECH_TERMS },
  { word: 'php', category: TECH_TERMS },
  { word: 'postgres', category: TECH_TERMS },
  { word: 'python', category: TECH_TERMS },
  { word: 'rails', category: TECH_TERMS },
  { word: 'react', category: TECH_TERMS },
  { word: 'redis', category: TECH_TERMS },
  { word: 'zapier', category: TECH_TERMS },

  // Job Roles & Skills (professional terms)
  { word: 'build', category: JOB_ROLES_AND_SKILLS },
  { word: 'coding', category: JOB_ROLES_AND_SKILLS },
  { word: 'design', category: JOB_ROLES_AND_SKILLS },
  { word: 'developer', category: JOB_ROLES_AND_SKILLS },
  { word: 'engineer', category: JOB_ROLES_AND_SKILLS },
  { word: 'leader', category: JOB_ROLES_AND_SKILLS },
  { word: 'mentor', category: JOB_ROLES_AND_SKILLS },
  { word: 'planning', category: JOB_ROLES_AND_SKILLS },
  { word: 'review', category: JOB_ROLES_AND_SKILLS },
  { word: 'scrum', category: JOB_ROLES_AND_SKILLS },
  { word: 'teacher', category: JOB_ROLES_AND_SKILLS },
  { word: 'testing', category: JOB_ROLES_AND_SKILLS },
  { word: 'training', category: JOB_ROLES_AND_SKILLS },

  // Personal Details (hobbies, interests, unique words)
  { word: 'art', category: PERSONAL_DETAILS },
  { word: 'baking', category: PERSONAL_DETAILS },
  { word: 'bread', category: PERSONAL_DETAILS },
  { word: 'cake', category: PERSONAL_DETAILS },
  { word: 'cooking', category: PERSONAL_DETAILS },
  { word: 'dance', category: PERSONAL_DETAILS },
  { word: 'dice', category: PERSONAL_DETAILS },
  { word: 'foraging', category: PERSONAL_DETAILS },
  { word: 'gaming', category: PERSONAL_DETAILS },
  { word: 'gardening', category: PERSONAL_DETAILS },
  { word: 'hiking', category: PERSONAL_DETAILS },
  { word: 'knitting', category: PERSONAL_DETAILS },
  { word: 'music', category: PERSONAL_DETAILS },
  { word: 'pasta', category: PERSONAL_DETAILS },
  { word: 'reading', category: PERSONAL_DETAILS },
  { word: 'wine', category: PERSONAL_DETAILS },

  // Soft Skills & Values (communication, teamwork, etc.)
  { word: 'courage', category: SOFT_SKILLS_AND_VALUES },
  { word: 'creativity', category: SOFT_SKILLS_AND_VALUES },
  { word: 'dedication', category: SOFT_SKILLS_AND_VALUES },
  { word: 'enthusiasm', category: SOFT_SKILLS_AND_VALUES },
  { word: 'kindness', category: SOFT_SKILLS_AND_VALUES },
  { word: 'leadership', category: SOFT_SKILLS_AND_VALUES },
  { word: 'learning', category: SOFT_SKILLS_AND_VALUES },
  { word: 'optimism', category: SOFT_SKILLS_AND_VALUES },
  { word: 'patience', category: SOFT_SKILLS_AND_VALUES },
  { word: 'respect', category: SOFT_SKILLS_AND_VALUES },
  { word: 'support', category: SOFT_SKILLS_AND_VALUES },
  { word: 'teamwork', category: SOFT_SKILLS_AND_VALUES },
  { word: 'trust', category: SOFT_SKILLS_AND_VALUES },
  { word: 'wisdom', category: SOFT_SKILLS_AND_VALUES },
];
